<div class="headContent" fxFlex="100" *ngIf="headLabel">
    <span class="head">
        Remarks
    </span>
</div>
<div fxFlex="100" class="inputs justify-fxstart" fxLayout="row wrap">
    <div class="align-item-fxstart" fxFlex="100" fxLayout="column" *ngIf="isEditable">
        <div class="expandable" fxLayout="column">
            <textarea name="remark" class="hw100" [placeholder]="placeholder" [name]="name" [(ngModel)]="data"
                [id]="name" [disabled]="disabled"></textarea>
            <div class="icon-set">
                <i MatSuffix id="i1" matTooltip="Coming Soon" matTooltipPosition="below" matTooltipHideDelay="2000"
                    class="flaticon-attachment"></i>
                <i MatSuffix id="i1" matTooltip="Coming Soon" matTooltipPosition="below" matTooltipHideDelay="2000"
                    class="flaticon-happy"></i>
            </div>
        </div>
    </div>



    <!-- <div fxFlex="100" class="cardr " fxLayout="row wrap">
        <div fxFlex="100" class="remark-head" fxLayout="row">
            <div class="fxapart" fxFlex="50">
                <div class="profile">
                    <span class="bgc-danger">AK</span>
                </div>
                <div class="inputTitle">
                    <p>Akshay Koppula</p>
                </div>
            </div>
            <div class="date" fxFlex="18">
                <small>Date: 23-09-2022</small>
            </div>
        </div>
        <div class="remarks bc-danger" fxFlex="92">
            <p>Test Remark Lorem ipsum dolor sit amet consectetur adipisicing elit. </p>
        </div>
    </div> -->
    <div fxFlex="100" class="cardr1" fxLayout="row" *ngIf="!isEditable">
        <div class="fxapart imgP" fxFlex="15">
            <div class="profile" >
                <!-- <span class="bgc-purple" *ngIf="updatedBy?.picture==null">{{updatedBy?.initials}}
                </span> -->
                <logzy-img-loader [profilePic]="true" [initials]="updatedBy?.initials" [src]="updatedBy?.picture?.document_file" border_radius="50%"></logzy-img-loader>
                <!-- <img *ngIf="updatedBy?.picture!=null" [src]="updatedBy?.picture?.document_file"> -->
            </div>
        </div>
        <div class="remarks " fxFlex="80" fxLayout="row wrap">
            <div class="fxapart mb-1em" fxFlex="100">
                <div class="inputTitle" >
                    <span>{{updatedBy?.first_name}} {{updatedBy?.last_name}}</span>
                </div>
                
                <!-- <div class="date" fxFlex="100">
                    <span>Last updated on: {{commentDate | date:'dd MMM, yyyy'}}</span>
                </div> -->
            </div>
            <div class="rtext" fxFlex="100">
                <p>{{_data==null || _data=="" ? '-' : _data}}</p>
                <p *ngIf="!isEditable && _data == null && forCustomerMaster">{{companyName}} added in system by
                    {{createdBy?.first_name}} {{createdBy?.last_name}} on {{createdAt | date:'dd MMM, yyyy'}}</p>
            </div>
        </div>
    </div>
</div>

<!-- <div class="viewLable" *ngIf="!isEditable">
    <span>{{_data}}</span>
</div> -->